import React from 'react';

import { ScreenContainerSafeAreaProvider } from '@components/ScreenContainer';
import { AuthRoute } from '@navigation/Routes';
import { createStackNavigator } from '@react-navigation/stack';
import LoginScreen from '@screens/Auth/Login';
import RegisterScreen from '@screens/Auth/Register';
import ResetPasswordScreen from '@screens/Auth/ResetPassword';
import StartScreen from '@screens/Start';

export type AuthStackParamList = {
  [AuthRoute.Start]: undefined;
  [AuthRoute.Login]: undefined;
  [AuthRoute.Register]: undefined;
  [AuthRoute.ResetPassword]: undefined;
};

const Stack = createStackNavigator<AuthStackParamList>();

export default function AuthStack() {
  return (
    <ScreenContainerSafeAreaProvider>
      <Stack.Navigator
        id={undefined}
        initialRouteName={AuthRoute.Start}
        screenOptions={{
          headerShown: false,
        }}>
        <Stack.Screen name={AuthRoute.Start} component={StartScreen} />
        <Stack.Screen name={AuthRoute.Login} component={LoginScreen} />
        <Stack.Screen name={AuthRoute.Register} component={RegisterScreen} />
        <Stack.Screen name={AuthRoute.ResetPassword} component={ResetPasswordScreen} />
      </Stack.Navigator>
    </ScreenContainerSafeAreaProvider>
  );
}
